import Vue from 'vue';
import { gsap } from 'gsap';
import scrollama from 'scrollama';

Vue.component('carousel-titles-component', {
    props: ['fixedImages'],

    data() {
        return {
        };
    },

    watch: {
    },

    mounted() {
        this.fadeInAnimation();

        if (this.fixedImages) {
            this.scrollUpAnimation();
        }

        this.arrowAnimation();
    },

    methods: {
        fadeInAnimation() {

            gsap.set('.carousel__title-text-line', { opacity: 0 })

            // instantiate the scrollama
            const scroller = scrollama();

            // setup the instance, pass callback functions
            scroller
                .setup({
                    step: 'body',
                    offset: 0.7,
                })
                .onStepEnter(response => {
                    // { element, index, direction }
                    gsap.to('.carousel__title-text-line', { opacity: 1, duration: 1, stagger: 0.2 })
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller.resize);
        },

        scrollUpAnimation() {
            const slideHeight = document.querySelector('.carousel .glide__slides').clientHeight;

            gsap.set('.carousel .glide__slides', { height: slideHeight });
            gsap.set('.carousel .glide__slides .block__read-more-holder', { opacity: 0 });

            const allImageElements = document.querySelectorAll('.carousel .glide__slide');
            allImageElements.forEach((element, index) => {
                gsap.set(element, { marginTop: 200 + (20 * (index + 1)) })
            });


            // instantiate the scrollama
            const scroller2 = scrollama();

            // setup the instance, pass callback functions
            scroller2
                .setup({
                    step: '.carousel-holder',
                    offset: 0.8,
                })
                .onStepEnter(response => {
                    // { element, index, direction }
                    gsap.to('.carousel .carousel__title-text-line', { opacity: 1, duration: 1, stagger: 0.2 })
                    gsap.to('.carousel .glide__slide', { marginTop: 0, duration: 1, ease: "power2.out", stagger: 0.1 })
                    gsap.to('.carousel .glide__slides .block__read-more-holder', { opacity: 1, duration: 1, stagger: 0.1, delay: 0.5 })
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller2.resize);

        },

        arrowAnimation() {

            gsap.set('.carousel__arrow--previous', { right: -50, opacity: 0 });
            gsap.set('.carousel__arrow--next', { left: -50, opacity: 0 })

            // instantiate the scrollama
            const scroller3 = scrollama();

            // setup the instance, pass callback functions
            scroller3
                .setup({
                    step: 'body',
                    offset: 0.9,
                })
                .onStepEnter(response => {
                    gsap.to('.carousel__arrow--previous', { right: 0, opacity: 1, duration: 0.5 });
                    gsap.to('.carousel__arrow--next', { left: 0, opacity: 1, duration: 0.5 })
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller3.resize);
        }

    },

    beforeDestroy() {
    },
});
